module.exports = __webpack_public_path__ + "img/smartcommerce-iconfont.bb472446.svg";